import { h } from 'preact'

const FaceIcon = ({ size = 74 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 74 74">
    <path
      fill="#8496AF"
      stroke="#8496AF"
      strokeWidth="0.8"
      d="M16.777 67.266a36.4 36.4 0 1040.446-60.53 36.4 36.4 0 00-40.446 60.53zm1.824-57.802A33.117 33.117 0 1155.4 64.536 33.117 33.117 0 0118.6 9.464zm26.453 21.648a7.848 7.848 0 108.72-13.051 7.848 7.848 0 00-8.72 13.05zm1.823-10.322a4.566 4.566 0 115.073 7.593 4.566 4.566 0 01-5.073-7.593zM20.226 31.112a7.848 7.848 0 108.72-13.052 7.848 7.848 0 00-8.72 13.052zM22.05 20.79a4.566 4.566 0 115.073 7.592 4.566 4.566 0 01-5.073-7.592zm22.255 27.24a10.331 10.331 0 003.026-7.306 1.641 1.641 0 10-3.283 0 7.048 7.048 0 11-14.096 0 1.641 1.641 0 10-3.283 0 10.331 10.331 0 0017.636 7.305z"
    />
  </svg>
)

export default FaceIcon
